var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn9VwcisF0Htsww(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z",
    fill: "#0E1F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5C23.4558 2.5 29.5 8.54416 29.5 16C29.5 23.4558 23.4558 29.5 16 29.5C8.54416 29.5 2.5 23.4558 2.5 16C2.5 8.54416 8.54416 2.5 16 2.5Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 9.30273C13.6083 9.30273 11.667 11.4234 11.667 14.0363C11.667 16.5988 13.5043 18.6815 15.9425 18.7573C15.9772 18.7573 16.0234 18.7573 16.0465 18.7573C16.0697 18.7573 16.1043 18.7573 16.1274 18.7573C16.139 18.7573 16.1505 18.7573 16.1505 18.7573C18.4848 18.6689 20.3221 16.5988 20.3337 14.0363C20.3337 11.4234 18.3923 9.30273 16.0003 9.30273Z",
    fill: "#0E1F33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0607 25.4093C22.6819 27.6319 19.5014 29.0007 16.0001 29.0007C12.4988 29.0007 9.3182 27.6319 6.93945 25.4093C7.26018 24.176 8.12882 23.0512 9.39838 22.1839C13.0467 19.7174 18.9802 19.7174 22.6017 22.1839C23.8847 23.0512 24.7399 24.176 25.0607 25.4093Z",
    fill: "#0E1F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn9VwcisF0Htsww);
export default __webpack_public_path__ + "static/media/mn9vwcis-f0htsww.8e03454335492e662bbc84ee4611cf39.svg";
export { ForwardRef as ReactComponent };